import { render, staticRenderFns } from "./LandPurchaseReport.vue?vue&type=template&id=4fe09e68"
import script from "./LandPurchaseReport.vue?vue&type=script&lang=js"
export * from "./LandPurchaseReport.vue?vue&type=script&lang=js"
import style0 from "./LandPurchaseReport.vue?vue&type=style&index=0&id=4fe09e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports